import React, { FC, useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './PageAuth.module.scss';
import { Alert } from 'esa-ui-library';
import { useParams } from 'react-router-dom';
import { NOT_AUTH_MESSAGE } from '../..';
import { AuthContext } from '../../../logic';
import { PropertyType, useStore } from '../../../common';
import { api } from '../../../api';

interface PageAuthProps {
	children: JSX.Element | JSX.Element[];
	onlyAdmin?: boolean;
	permission: string;
}

const PageAuth: FC<PageAuthProps> = ({ children, onlyAdmin, permission }): JSX.Element => {
	const { user } = useContext(AuthContext);
	const [, dispatch] = useStore();
	const { id }: PropertyType = useParams();
	const isCurrentUser = user?.id === +id;
	const hasPermissions = user?.permissions?.isSuperAdmin || user?.permissions?.[permission];
	const isAuthorized = onlyAdmin ? hasPermissions : hasPermissions || isCurrentUser;

	api.interceptors.response.use(
		(request) => request,
		(error) => {
			const msg = error.response?.data?.errors?.name;
			if (msg) {
				dispatch('GLOBAL_ERROR', msg);
			}
			return Promise.reject({ ...error });
		}
	);

	return (
		<>
			{isAuthorized && children}
			{!isAuthorized && <Alert className={styles.Alert} danger text={NOT_AUTH_MESSAGE} />}
		</>
	);
};

PageAuth.propTypes = {
	onlyAdmin: PropTypes.bool,
	permission: PropTypes.string.isRequired,
};

export { PageAuth };
